import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes, useSearchParams } from 'react-router-dom';

import { EClient } from '@enums/api.enum';
import { ERoutes } from '@enums/routes.enum';
import { EStyles } from '@enums/style.enum';
import useTripSocket from '@hooks/useTripSocket';
import Search from '@pages/Search/Search';
import TripInfo from '@pages/TripInfo/TripInfo';
import Trips from '@pages/Trips/Trips';
import { reset, setToken } from '@store/auth/authSlice';
import type { RootState } from '@store/store';
import { createSocket } from '@utils/socket';

import ProtectedRoute from './ProtectedRoute/ProtectedRoute';

const AppRoutes = () => {
	const storeToken = useSelector((state: RootState) => state.auth.token);

	const [searchParams] = useSearchParams();
	const dispatch = useDispatch();
	const { disconnectTripsSocket } = useTripSocket();

	useEffect(() => {
		const token = searchParams.get(EClient.token);
		const cleanToken = token?.replace(/['"]+/g, EStyles.emptyQuote);

		if (cleanToken) {
			dispatch(setToken(cleanToken));
		}
		if (cleanToken || storeToken) {
			createSocket(cleanToken || (storeToken as string));
		}
	}, [searchParams, dispatch, storeToken]);

	useEffect(() => {
		return () => {
			dispatch(reset());
			disconnectTripsSocket();
		};
	}, []);

	return (
		<Routes>
			<Route path={ERoutes.search} element={<Search />} />

			<Route element={<ProtectedRoute />}>
				<Route path={ERoutes.trips} element={<Trips />} />
				<Route path={ERoutes.tripInfo} element={<TripInfo />} />
			</Route>

			<Route path={ERoutes.any} element={<Navigate to={ERoutes.search} replace />} />
		</Routes>
	);
};

export default AppRoutes;
